import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue";
const _hoisted_1 = { class: "flex justify-center" };
const _hoisted_2 = { class: "grow text-[#003366] font-semibold leading-none text-[1.1rem]" };
const _hoisted_3 = { class: "title" };
const _hoisted_4 = { class: "flex flex-col gap-[0.31rem] items-start ml-[30px] -mt-[5px]" };
const _hoisted_5 = { class: "text-[#4A6476]" };
const _hoisted_6 = ["href"];
const _hoisted_7 = { class: "flex flex-row justify-center items-center py-[0.3rem] px-[0.5rem] gap-[0.5rem] text-[#005a9c] rounded-[8px] bg-[#F0F2F4] cursor-pointer transition-shadow duration-200 font-semibold" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createBlock($setup["EnItem"], {
        variant: "outline",
        class: "group rounded-[8px] relative shadow-[0_2px_2px_rgba(13,48,72,0.1)] transition-all duration-300 bg-white my-2"
    }, {
        header: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", {
                    class: _normalizeClass(["icon-wrapper flex items-center justify-center rounded-[0.44rem] border-0 border-[#BBCFDA] mr-[10px]", {
                            'bg-white text-blue-600': $setup.notificationType === 'info',
                            'bg-white text-yellow-600': $setup.notificationType === 'warning',
                            'bg-white text-red-600': $setup.notificationType === 'error',
                            'bg-[#EAF5FB]': $setup.notificationType !== 'info' && $setup.notificationType !== 'warning' && $setup.notificationType !== 'error'
                        }])
                }, [
                    (_openBlock(), _createBlock(_resolveDynamicComponent($setup.icon), { size: 18 }))
                ], 2 /* CLASS */),
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, _toDisplayString($props.item?.title || $props.item?.type), 1 /* TEXT */)
                ]),
                _createElementVNode("div", {
                    class: "opacity-0 transition-opacity duration-200 group-hover:opacity-100 close-button-container w-[17px] h-[17px] bg-[#EE3E3E] text-white rounded-full absolute flex -top-[9px] -right-[9px] cursor-pointer",
                    onClick: $setup.closeNotification
                }, [
                    _createVNode($setup["X"], {
                        class: "m-auto",
                        color: "#fff",
                        size: 14
                    })
                ])
            ])
        ]),
        footer: _withCtx(() => [
            ($props.item?.url && $props.item?.triggerDownload)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    href: $props.item?.url,
                    class: "notification-link ml-[34px] hover:no-underline flex"
                }, [
                    _createElementVNode("div", _hoisted_7, [
                        _createVNode($setup["EnExportIcon"]),
                        _createElementVNode("span", null, _toDisplayString($setup.t('common.notifications.downloadFiles')), 1 /* TEXT */)
                    ])
                ], 8 /* PROPS */, _hoisted_6))
                : _createCommentVNode("v-if", true)
        ]),
        default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, _toDisplayString($props.item?.message), 1 /* TEXT */)
            ])
        ]),
        _: 1 /* STABLE */
    }));
}
